import { useEffect, useRef, useState } from "react";
import JobCard from "../JobCard/JobCard";
import Pagination from "../Pagination/Pagination";
import styles from "./JobList.module.css";

import Scrolleddown from '../../../../animation/jobs/dropdown icon.svg';
import Scrolledup from '../../../../animation/jobs/scrolling icon.svg';



const JobList = ({ jobs, onJobSelect, selectedJobId, pagination, currentPage, onPageChange, loading }) => {
  const jobsPerPage = 10;
  const isMockData = !pagination?.count;
  const [mockPage, setMockPage] = useState(1);

  const jobListRef = useRef(null);

  const displayJobs = isMockData
    ? jobs.slice((mockPage - 1) * jobsPerPage, mockPage * jobsPerPage)
    : jobs;

  const totalPages = isMockData
    ? Math.ceil(jobs.length / jobsPerPage)
    : Math.ceil((pagination?.count || 0) / jobsPerPage);

  const activePage = isMockData ? mockPage : currentPage;

  const handlePageChange = (page) => {
    if (isMockData) setMockPage(page);
    else if (onPageChange) {
      const offset = (page - 1) * jobsPerPage;
      const url = `${process.env.REACT_APP_API_BASE_URL}api/v1/jobs/?limit=${jobsPerPage}&offset=${offset}`;
      onPageChange(url, false);
    }
  };



  useEffect(() => {
    const container = jobListRef.current;
    if (!container) return;

    const handleScroll = () => {
      if (window.innerWidth > 768) return;

      const { scrollTop, scrollHeight, clientHeight } = container;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

      if (isAtBottom && pagination?.next && !loading) {
        onPageChange(pagination.next, true);
      }
    };

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [pagination?.next, loading, onPageChange]);

  const scroll = (amount) => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ top: amount, behavior: "smooth" });
    }
  };

  return (
    <>
      <div className={styles.joblistParent}>
        <img src={Scrolledup}
          onClick={() => scroll(-100)}
          className={styles.arrow_up}
        />
        <div className={styles.jobListContainer} ref={jobListRef}>
          {displayJobs.map((job, index) => (
            <div className={styles.job_item} key={job.id || index}>
              <JobCard
                job={job}
                onClick={() => onJobSelect(job)}
                isSelected={selectedJobId === job.id}
              />
            </div>
          ))}



          <img src={Scrolleddown} onClick={() => scroll(100)}
            className={styles.arrow_down} />

          <Pagination totalPages={totalPages} currentPage={activePage} onPageChange={handlePageChange} />
        </div>
      </div>
    </>
  );
};

export default JobList;